import { Dealer } from 'lib/models/Dealer';
import { DealerReview } from 'lib/models/DealerReview';

interface DealerPageProps {
  url: string;
  titleTag?: string;
  description?: string;
  metadescription?: string;
  mapUrl?: string;
  email?: string;
  phone?: string;
  dealer: Dealer;
  reviews: DealerReview[];
  enabled: boolean;
}

function constructDealerPageTitle({ displayName, address: { city, state } }: Dealer): string {
  return `${displayName} | ${city}, ${state}`;
}

export type DealerPage = DealerPageProps & {
  titleTag: string;
};

export function createDealerPage(props: DealerPageProps): DealerPage {
  const titleTag = props.titleTag || constructDealerPageTitle(props.dealer);
  return {
    ...props,
    titleTag,
  };
}
